import React from 'react';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '@components/Spinner/LoadingSpinner';
import { LambdaHistoryItem as LambdaHistoryItemType } from '@api/lambdaOperationsApi';
import { ApiError } from '@api/RestClient';
import LambdaHistoryItem from './LambdaHistoryItem';

type Props = {
    history: LambdaHistoryItemType[];
    loading: boolean;
    error: ApiError | null;
    checkedById: Record<string, boolean>;
    layerLoadingById: Record<string, boolean>;
    restartingById: Record<string, boolean>;
    onLayerToggle: (item: LambdaHistoryItemType, checked: boolean) => void;
    onOpenDashboard: (item: LambdaHistoryItemType) => void;
    onRestart: (item: LambdaHistoryItemType) => void;
};

const LambdaHistory = ({
    history,
    loading,
    error,
    checkedById,
    layerLoadingById,
    restartingById,
    onLayerToggle,
    onOpenDashboard,
    onRestart,
}: Props) => {
    const { t } = useTranslation();

    if (loading) {
        return (
            <div className="lambda-operations-empty">
                <LoadingSpinner size="18px" backgroundColor="transparent" />
                <span>{t('lambda-operations.loading-history')}</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="lambda-operations-empty">
                {t('lambda-operations.failed-load-history')}
            </div>
        );
    }

    if (!history.length) {
        return (
            <div className="lambda-operations-empty">
                {t('lambda-operations.no-history')}
            </div>
        );
    }

    return (
        <div className="lambda-history-list">
            {history.map(item => (
                <LambdaHistoryItem
                    key={item.id}
                    item={item}
                    checked={!!checkedById[item.id]}
                    layerLoading={!!layerLoadingById[item.id]}
                    restarting={!!restartingById[item.id]}
                    onLayerToggle={onLayerToggle}
                    onOpenDashboard={onOpenDashboard}
                    onRestart={onRestart}
                />
            ))}
        </div>
    );
};

export default LambdaHistory;
